export function getCandidateGeocode(candidate = {}) {
  const mapped = candidate.rawPayload?.mapped || {};
  const metadata = candidate.rawPayload?.rawMetadata || {};
  const latitude = Number(mapped.latitude ?? metadata.latitude);
  const longitude = Number(mapped.longitude ?? metadata.longitude);
  if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
    return { latitude: null, longitude: null };
  }
  return { latitude, longitude };
}

export function buildCandidateMapQuery(candidate = {}) {
  const { latitude, longitude } = getCandidateGeocode(candidate);
  if (latitude != null && longitude != null) {
    return `${latitude},${longitude}`;
  }
  const parts = [
    candidate.rawName || candidate.normalizedName,
    candidate.rawAddress || candidate.normalizedAddress,
    candidate.rawMunicipality,
    "Colombia",
  ].filter(Boolean);
  return parts.join(", ");
}

export function buildGoogleMapsSearchUrl(query) {
  if (!query) return null;
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;
}

export function buildGoogleMapsEmbedUrl(query, locale = "en-US") {
  if (!query) return null;
  const hl = locale.startsWith("es") ? "es" : locale.startsWith("ru") ? "ru" : "en";
  return `https://www.google.com/maps?q=${encodeURIComponent(query)}&hl=${hl}&z=15&output=embed`;
}

export function buildGoogleSearchUrl(query) {
  if (!query) return null;
  return `https://www.google.com/search?q=${encodeURIComponent(query)}`;
}

export function buildTelHref(phone) {
  if (!phone) return null;
  const normalized = String(phone).replace(/[^\d+]/g, "");
  return normalized ? `tel:${normalized}` : null;
}

export function buildMailtoHref(email) {
  if (!email) return null;
  return `mailto:${email}`;
}

export function buildWebsiteHref(website) {
  if (!website) return null;
  const value = String(website).trim();
  if (!value) return null;
  return /^https?:\/\//i.test(value) ? value : `https://${value}`;
}

export function getCandidateDiscoveryMeta(candidate = {}) {
  const payload = candidate.rawPayload || {};
  return {
    sourceUrl: payload.sourceUrl || null,
    collectionRunId: payload.collectionRunId || null,
    discoveryQuery: payload.query?.term || payload.rawMetadata?.query || null,
    discoveryOrigin: payload.query?.origin || null,
    discoveryCategoryKey: payload.query?.categoryKey || null,
    discoveryMunicipalityName: payload.query?.municipalityName || null,
    connectorObservedAt: payload.lineage?.connectorObservedAt || null,
  };
}

export function getCandidateNormalizationInsights(candidate = {}) {
  const fields = candidate.normalizationData?.fields || {};
  const mapped = candidate.rawPayload?.mapped || {};
  const metadata = candidate.rawPayload?.rawMetadata || {};
  const { latitude, longitude } = getCandidateGeocode(candidate);
  return {
    vendorKindHint: fields.name?.vendorKindHint || mapped.vendorKindHint || metadata.vendorKindHint || "registered_company",
    nameConfidence: fields.name?.confidence || null,
    categoryStatus: fields.category?.status || null,
    categoryRaw: fields.category?.raw || candidate.rawCategory || null,
    municipalityStatus: fields.municipality?.status || null,
    municipalityRaw: fields.municipality?.raw || candidate.rawMunicipality || null,
    addressConfidence: fields.address?.confidence || null,
    phoneDisplay: fields.phone?.display || candidate.rawPhone || candidate.normalizedPhone,
    emailDisplay: fields.email?.display || candidate.rawEmail || candidate.normalizedEmail,
    websiteDisplay: fields.website?.display || candidate.rawWebsite || candidate.normalizedWebsite,
    addressDisplay: fields.address?.rawValue || candidate.rawAddress || candidate.normalizedAddress,
    latitude,
    longitude,
    geocodeDisplay: latitude != null && longitude != null ? `${latitude.toFixed(6)}, ${longitude.toFixed(6)}` : null,
    neighborhoodName: mapped.neighborhoodName || metadata.neighborhoodName || null,
  };
}
